var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupHeaderMarks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 36,
    viewBox: "0 0 94 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1748_55816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -43,
    width: 125,
    height: 126
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8146 22.881C67.0693 21.138 68.7233 21.2626 70.1284 24.055C71.1066 25.9758 71.9426 27.0786 74.2547 27.5054C77.0471 28.0212 76.7447 30.4934 76.4068 32.9656L72.9297 33.4369C71.6402 32.3075 69.6393 31.3916 69.4348 30.191C68.7945 26.6694 64.4726 26.1891 63.8146 22.881Z",
    fill: "#1A2A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0483 11.5337C51.9229 10.2442 50.4645 9.88847 50.1088 9.05254C48.9972 6.5003 46.8629 5.18417 44.7731 3.71685C43.3414 2.76532 41.7852 1.74259 41.8297 -0.453933C44.2218 -1.29875 45.609 0.390975 46.6584 1.4759C49.1928 4.17042 52.8744 5.96677 54.0483 11.5337Z",
    fill: "#1A2A55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0626 15.9274C80.1329 15.0648 78.1765 14.1933 76.2112 13.3485C75.6408 13.1574 75.1527 12.7774 74.8276 12.2713C74.5026 11.7651 74.3601 11.1632 74.4236 10.5651C74.4192 9.81228 74.7098 9.08759 75.233 8.54633C75.5803 8.40246 75.9562 8.34125 76.3312 8.36748C76.7062 8.39372 77.07 8.50667 77.3939 8.69749C79.1814 9.91581 80.8533 11.3209 82.534 12.6815C83.1921 13.215 83.0586 14.0066 82.0626 15.9274Z",
    fill: "#1A2A55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9554 4.25962C89.8865 5.00661 89.8864 5.00664 88.3658 -0.266813C93.0612 -1.72523 93.7904 -1.2984 94.9554 4.25962Z",
    fill: "#1A2A55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7828 18.2127C85.2639 17.5102 87.0425 18.7195 88.6521 20.1691C90.0572 21.414 90.1994 22.1789 89.8348 24.8023C85.6196 22.9704 85.255 22.6414 82.7828 18.2127Z",
    fill: "#1A2A55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6707 -4.62489C64.2852 -4.09132 66.2327 -3.35316 67.4866 -1.40563C68.0201 -0.569702 68.4826 0.372937 67.5755 1.31558C67.425 1.5159 67.2322 1.6807 67.0109 1.79832C66.7897 1.91594 66.5453 1.98349 66.295 1.99622C66.0447 2.00894 65.7947 1.96654 65.5626 1.87197C65.3306 1.77741 65.1222 1.63301 64.9521 1.44899C63.7734 0.381003 62.704 -0.801728 61.7596 -2.08155C61.4128 -2.57066 61.6885 -3.48661 61.6707 -4.62489Z",
    fill: "#1A2A55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0376 31.552C26.5813 31.1314 25.1577 30.6054 23.7779 29.978C23.4756 29.8179 23.5555 28.564 23.7689 27.906C23.8578 27.657 25.0228 27.3813 25.2896 27.6481C26.4502 28.5472 27.5633 29.5059 28.6244 30.5205L28.0376 31.552Z",
    fill: "#1A2A55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9566 20.1244C37.2945 19.9999 37.6592 19.7242 37.9882 19.7687C38.4559 19.7665 38.9068 19.9429 39.2489 20.2618C39.5909 20.5808 39.7985 21.0183 39.829 21.485C39.7743 21.6338 39.6879 21.7689 39.5758 21.881C39.4637 21.9931 39.3286 22.0795 39.1798 22.1342C38.408 21.6888 37.6626 21.1989 36.9476 20.6669C36.8232 20.6491 36.9121 20.3467 36.9566 20.1244Z",
    fill: "#1A2A55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0977 8.11877C27.5036 7.59409 28.3573 9.28372 29.7535 9.95068C27.6904 11.1067 26.7655 9.23926 24.0977 8.11877Z",
    fill: "#1A2A55"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4965 26.6879L93.7277 27.666C93.3987 27.5682 92.9896 27.5683 92.7762 27.3549C92.5627 27.1415 92.6161 26.7502 92.5628 26.43L93.4965 26.6879Z",
    fill: "#1A2A55"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1748_55816)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 104.867,
    height: 71.1375,
    transform: "rotate(-45 0 32)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupHeaderMarks);
export default __webpack_public_path__ + "static/media/popupHeaderMarks.d1d0b2de93e10d377beda57a660f1fcd.svg";
export { ForwardRef as ReactComponent };